import React, { useEffect, useState } from 'react'

import {
  Button,
  ButtonsContainer,
  OnboardTitle,
  Icons,
  CircularProgress,
} from 'components/Antifraude'
import validateStageOnboarding from 'utils/validateStage'
import { useSelector } from 'react-redux'
import { roles } from 'utils/constants/roles'

import Container from './styles'

export default (props) => {
  const { history } = props

  const [loading, setLoading] = useState(false)
  const { token } = useSelector((state) => state.token)
  
  function handleContinue() {
    history.replace({
      pathname: '/ocr-options',
    })
  }

  const handleLoading = (newState) => {
    setLoading(newState)
  }

  useEffect(() => {
    validateStageOnboarding(token, history, roles.DOCUMENT_OCR, handleLoading)
  }, [])

  return (
    <Container
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    >

      {loading ? (
        
          <div className="loading">
            <div className="loading__container" style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress style={{ textAlign: 'center' }} />
            </div>
          </div>
       
      ) : (
        <React.Fragment>
          <span className="center">
            <OnboardTitle>Envie uma foto do seu documento.</OnboardTitle>
            <OnboardTitle>Dicas para garantir o melhor resultado:</OnboardTitle>
          </span>

          <table className="tip">
            <tbody>
              <tr>
                <td>
                  <Icons icon="light" />
                </td>
                <td>
                  Envie a foto do documento sem a capinha (caso tenha), sobre uma
                  superfície plana.
                  </td>
              </tr>
              <tr>
                <td>
                  <Icons icon="light" />
                </td>
                <td>O seu documento deve ser enquadrado na foto.</td>
              </tr>
              <tr>
                <td>
                  <Icons icon="light" />
                </td>
                <td>Envie uma foto nítida, evite fotos tremidas ou borradas.</td>
              </tr>
              <tr>
                <td>
                  <Icons icon="light" />
                </td>
                <td>Sendo uma CNH Digital, envie o PDF exportado pelo aplicativo ou uma imagem do documento completo.</td>
              </tr>
            </tbody>
          </table>

          <ButtonsContainer>
            <Button
              onClick={handleContinue}
            >
              Sim, entendi!
              </Button>
          </ButtonsContainer>
        </React.Fragment>
      )}
    </Container>
  )
}
